import { useCallback } from 'react';

import { useParams } from 'react-router-dom';

import useFlowState from '#client/hooks/flow/useFlowState';
import useFlowNavigation from '#client/hooks/useFlowNavigation';
import useShouldPromptLogin from '#client/hooks/useShouldPromptLogin';

export function useSaveContactInfo({ onLoginPrompt }) {
  const { goToNextPage } = useFlowNavigation();
  const { flowPage } = useParams();
  const { set } = useFlowState();
  const shouldPromptLogin = useShouldPromptLogin();

  const handleSkip = useCallback(() => {
    goToNextPage();
  }, [goToNextPage]);

  const handleSubmit = useCallback(
    async (formData) => {
      const promptLogin = await shouldPromptLogin(formData.email);

      if (promptLogin) {
        onLoginPrompt();
      } else {
        set('contactInfo', (currentData) => ({
          ...currentData,
          ...formData,
          pageSource: flowPage
        }));
        goToNextPage();
      }
    },
    [flowPage, goToNextPage, onLoginPrompt, set, shouldPromptLogin]
  );

  return { handleSkip, handleSubmit };
}
